import { ADDNEW, REMOVE } from './actionTypes';

export const addNew = (value) => {
  return {
    type: ADDNEW,
    payload: value,
  };
};

export const remove = (id) => {
  return {
    type: REMOVE,
    payload: id,
  };
};
